var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_75_372)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1434 15.6363C31.4634 15.9346 30.7388 16.1323 29.9834 16.2283C30.7605 15.7643 31.3536 15.0352 31.6325 14.1563C30.9079 14.5883 30.1079 14.8934 29.2554 15.0637C28.5674 14.3312 27.5868 13.8774 26.5171 13.8774C24.4416 13.8774 22.7708 15.562 22.7708 17.6272C22.7708 17.9243 22.7959 18.21 22.8576 18.482C19.7411 18.33 16.9834 16.8363 15.1308 14.5609C14.8073 15.122 14.6176 15.7643 14.6176 16.4557C14.6176 17.754 15.2862 18.9049 16.2828 19.5712C15.6805 19.5597 15.0896 19.3849 14.5891 19.1094C14.5891 19.1209 14.5891 19.1357 14.5891 19.1506C14.5891 20.9723 15.8885 22.4854 17.5925 22.834C17.2874 22.9174 16.9548 22.9574 16.6096 22.9574C16.3696 22.9574 16.1274 22.9437 15.8999 22.8934C16.3856 24.378 17.7639 25.4694 19.4028 25.5049C18.1274 26.5026 16.5079 27.1037 14.7548 27.1037C14.4473 27.1037 14.1525 27.09 13.8576 27.0523C15.5182 28.1232 17.4862 28.7346 19.6085 28.7346C26.5068 28.7346 30.2782 23.0203 30.2782 18.0672C30.2782 17.9014 30.2725 17.7414 30.2645 17.5826C31.0085 17.0546 31.6336 16.3952 32.1434 15.6363Z",
    fill: "#626975"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_75_372",
    x: 0.428572,
    y: 0.714286,
    width: 45.1429,
    height: 45.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.28571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.705882 0 0 0 0 0.72549 0 0 0 0 0.780392 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_75_372"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_75_372",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8e42b6cf.svg";
export { ForwardRef as ReactComponent };